import { render } from "./metodologia.vue?vue&type=template&id=2a89831e"
import script from "./metodologia.vue?vue&type=script&lang=js"
export * from "./metodologia.vue?vue&type=script&lang=js"

import "./metodologia.vue?vue&type=style&index=0&id=2a89831e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__